const _ = {
  cape_hh_groupa: "A",
  cape_hh_groupb: "B",
  cape_hh_groupc: "C",
  cape_hh_groupd: "D",
  cape_hh_groupe: "E",
  cape_hh_groupf: "F",
  cape_hh_groupg: "G",
  cape_hh_grouph: "H",
  cape_hh_groupi: "I",
  cape_hh_groupj: "J",
  cape_hh_groupk: "K",
  cape_hh_groupl: "L",
  cape_hh_groupm: "M",
  cape_hh_groupn: "N",
  cape_hh_groupo: "O",
  cape_hh_groupp: "P",
  cape_hh_groupq: "Q",
  cape_hh_groupr: "R",
  cape_hh_groups: "S"
}, h = {
  Census_Household_Count: "",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
  K: "K",
  L: "L",
  M: "M",
  N: "N",
  O: "O",
  P: "P",
  Q: "Q"
};
export {
  _ as MOSAIC_POPULATION_GROUP_MAP,
  h as PERSONA_LIVE_POPULATION_GROUP_MAP
};
//# sourceMappingURL=index.es452.js.map
